<template>
  <closeable-tag
    :active="active"
    @close="$emit('close')"
    @open="$emit('open')"
    :icon="['fas', 'square-check']"
  >
    <span>{{ label }}</span>
  </closeable-tag>
</template>

<script>
import CloseableTag from "./CloseableTag.vue";

export default {
  name: "CloseableDecisionTag",
  components: {
    CloseableTag
  },
  props: {
    active: {
      type: Boolean,
      default: true
    },
    label: {
      type: String
    }
  }
};
</script>
